import React from "react";
import choosesemars from "../../Images/(why-choose-semars)-AboutUs.webp";

const WhyChooseSemars = () => {
  return (
    <div className="relative w-full py-20 text-white bg-[linear-gradient(rgba(25,25,25,0.95),rgba(124,92,55,0.95))]">
      <div className="container mx-auto px-6 lg:px-8">
        {/* Main Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-8">
            Why Choose Semars Holding?
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center max-w-7xl mx-auto">
          {/* Left Side - Content Cards */}
          <div className="order-2 lg:order-1 space-y-6">
            {/* Card 1 - Unparalleled Market Expertise */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/15 transition-all duration-300">
              <h3 className="text-xl lg:text-2xl font-bold text-[#C99C48] mb-3">
                Led by Experience
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                 Mr. Sabeel Sajid brings 20+ years of global consulting, defense, 
                 investment, and diplomatic exposure to every engagement.
              </p>
            </div>

            {/* Card 2 - Exclusive Investment Access */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/15 transition-all duration-300">
              <h3 className="text-xl lg:text-2xl font-bold text-[#C99C48] mb-3">
                 KSA Focused, Globally Connected
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                With strong ties to Saudi royal families, regulators, and 
                decision-makers, we open doors that others can’t.
              </p>
            </div>

            {/* Card 3 - End-to-End Support */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/15 transition-all duration-300">
              <h3 className="text-xl lg:text-2xl font-bold text-[#C99C48] mb-3">
                Comprehensive Advisory
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                From legal structuring to post-launch growth, we walk with you 
                through the full lifecycle. 
              </p>
            </div>

            {/* Card 4 - Proven Track Record */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/15 transition-all duration-300">
              <h3 className="text-xl lg:text-2xl font-bold text-[#C99C48] mb-3">
                Track Record of Results:
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                 Our work has helped companies scale, win deals, and build trust 
                 in KSA’s complex regulatory landscape.
              </p>
            </div>

             <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/15 transition-all duration-300">
              <h3 className="text-xl lg:text-2xl font-bold text-[#C99C48] mb-3">
                Personalized Strategy
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                 Each client receives a customized roadmap, developed with local 
                 realities and future ambitions in mind
              </p>
            </div>
          </div>
           
           

          {/* Right Side - Image */}
          <div className="order-1 lg:order-2" data-aos="flip-up">
            <div className="relative">
              <img
                src={choosesemars}
                alt="Saudi Arabia Landmark - Makkah Clock Tower"
                className="w-full h-auto rounded-2xl object-cover shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseSemars;
